import {StreamType} from "../../../interfaces/StreamType";
import {Language} from "../../../interfaces/LanguageInterface";
import {Province} from "../../../interfaces/Province";
import {LicenseType} from "../../../interfaces/LicenseType";

export interface StaticDataState {
    services: StreamType[];
    languages: Language[];
    cities: string[];
    provinces: Province[];
    licenseTypes: LicenseType[];
    isLoading: boolean;
    isLoaded: boolean;
    lastFetched: number | null;
    error: string | null;
}

export const FETCH_STATIC_DATA_REQUEST = 'FETCH_STATIC_DATA_REQUEST';
export const FETCH_STATIC_DATA_SUCCESS = 'FETCH_STATIC_DATA_SUCCESS';
export const FETCH_STATIC_DATA_FAILURE = 'FETCH_STATIC_DATA_FAILURE';
export const CLEAR_STATIC_DATA = 'CLEAR_STATIC_DATA';

interface FetchStaticDataRequestAction {
    type: typeof FETCH_STATIC_DATA_REQUEST;
}

interface FetchStaticDataSuccessAction {
    type: typeof FETCH_STATIC_DATA_SUCCESS;
    payload: {
        services: StreamType[];
        languages: Language[];
        cities: string[];
        provinces: Province[];
        licenseTypes: LicenseType[];
    };
}

interface FetchStaticDataFailureAction {
    type: typeof FETCH_STATIC_DATA_FAILURE;
    payload: string;
}

interface ClearStaticDataAction {
    type: typeof CLEAR_STATIC_DATA;
}

export type StaticDataActionTypes =
    | FetchStaticDataRequestAction
    | FetchStaticDataSuccessAction
    | FetchStaticDataFailureAction
    | ClearStaticDataAction;
